import React from 'react';
import CTASection from '../components/CTASection';
import '../styles/Terms.css';

const Terms = () => {
    return (
        <div>
            <div className="terms-page section-marg">
                <div className="container">
                    <h1>Terms of Service</h1>
                    <p className="updated mb-16 mt-16"><b>Last updated:</b> January 2, 2026</p>
                    <div className="terms-opener">
                        <p>
                            THESE TERMS OF SERVICE (THE "TERMS") ESTABLISH THE LEGAL AGREEMENT BETWEEN YOU AND FIKTION REGARDING YOUR USE OF OUR CREATIVE WRITING AND STORY DEVELOPMENT PLATFORM (THE "SERVICE"). BY REGISTERING FOR AN ACCOUNT, SUBSCRIBING TO A PAID PLAN, ACCESSING OUR WEB-BASED APPLICATION, OR OTHERWISE USING THE SERVICE IN ANY MANNER, YOU ACKNOWLEDGE THAT YOU HAVE READ, UNDERSTAND, AND AGREE TO BE BOUND BY ALL OF THESE TERMS.
                        </p>
                        <p>
                            IF YOU ARE ENTERING INTO THESE TERMS ON BEHALF OF AN ORGANIZATION, COMPANY, OR OTHER LEGAL ENTITY, YOU REPRESENT THAT YOU HAVE THE LEGAL AUTHORITY TO BIND THAT ENTITY TO THESE TERMS, IN WHICH CASE "YOU" WILL REFER TO THAT ENTITY. IF YOU LACK SUCH AUTHORITY, OR IF YOU OR YOUR ENTITY DO NOT AGREE WITH ANY PART OF THESE TERMS, YOU MUST NOT ACCEPT THESE TERMS AND YOU ARE NOT PERMITTED TO USE THE SERVICE. CERTAIN TERMS USED IN THIS DOCUMENT ARE DEFINED IN THE SECTIONS BELOW.
                        </p>
                    </div>
                    <div className="mb-24">
                        <h3 className="page-title mb-8">
                            0. Information
                        </h3>
                        <p className="page-intro">
                        The Service is operated by: 
                        <br />
                        Martin Balle 
                        <br />
                        <a href="mailto:help@fiktion.io">help@fiktion.io</a> <br />
                        </p>
                    </div>
                    <div className="mb-24">
                        <h3 className="page-title mb-8">
                            1. Acceptance of Terms
                        </h3>
                        <p className="page-intro">
                            By accessing or using Fiktion ("the Service"), you agree to be bound by these Terms of Service ("Terms"). If you do not agree to these Terms, you may not use the Service.
                        </p>
                    </div>

                    <div className="mb-24">
                        <h3 className="page-title mb-8">
                            2. Description of Service
                        </h3>
                        <p className="page-intro">
                            Fiktion is a cloud-based creative writing and story development platform that enables users to write and edit scripts, manage characters, locations, scenes, and sequences, organize story ideas and notes, and export content in various formats including PDF and XML.
                        </p>
                    </div>

                    <div className="mb-24">
                        <h3 className="page-title mb-8">
                            3. User Accounts and Registration
                        </h3>
                        <p className="page-intro mb-16">
                            <b>3.1 Account Creation</b><br />
                            To use the Service, you must create an account and provide accurate and complete information during registration. You are responsible for maintaining the security of your account credentials. You must be at least 15 years old to use the Service.
                        </p>
                        <p className="page-intro">
                            <b>3.2 Account Security</b><br />
                            You are responsible for all activities that occur under your account, whether authorized by you or not. You must immediately notify us of any unauthorized use of your account or any other breach of security. We are not liable for any loss or damage arising from unauthorized access to your account.
                        </p>
                    </div>

                    <div className="mb-24">
                        <h3 className="page-title mb-8">
                            4. User Responsibilities
                        </h3>
                        <p className="page-intro mb-16">
                            <b>4.1 Content Ownership</b><br />
                            You retain all ownership rights to the content you create using the Service. You are solely responsible for the content you create, store, or transmit through the Service, and you represent and warrant that you have all necessary rights to use and store such content.
                        </p>
                        <p className="page-intro mb-16">
                            <b>4.2 Backup Responsibility</b><br />
                            <b>IMPORTANT:</b> You are solely responsible for maintaining local backups of your content. The Service provides export functionality in PDF and XML formats for your convenience, and we strongly recommend that you regularly export and save local backups of your work. While we implement industry-standard security measures and backup systems, we cannot guarantee that your data will never be lost, corrupted, or become inaccessible. We are not liable for any loss of data, content, or information stored on the Service, and you acknowledge that regular local backups are essential to protect your work.
                        </p>
                        <p className="page-intro">
                            <b>4.3 Acceptable Use</b><br />
                            You agree not to use the Service for any illegal or unauthorized purpose, violate any laws in your jurisdiction, or infringe upon the intellectual property rights of others. You shall not upload malicious code, viruses, or harmful content, attempt to gain unauthorized access to the Service or other users' accounts, or interfere with or disrupt the Service or servers connected to the Service.
                        </p>
                    </div>

                    <div className="mb-24">
                        <h3 className="page-title mb-8">
                            5. Data Storage and Security
                        </h3>
                        <p className="page-intro mb-16">
                            <b>5.1 Data Storage</b><br />
                            Your content is stored on secure cloud servers hosted on Firebase and Google Cloud Platform. All data is encrypted both in transit and at rest, and we implement industry-standard security measures to protect your information.
                        </p>
                        <p className="page-intro mb-16">
                            <b>5.2 Security Measures</b><br />
                            All data transmission is encrypted using SSL/TLS protocols. Sensitive content including scripts, characters, locations, and ideas is encrypted before storage. User authentication is required to access your data, and we perform regular security updates and monitoring to maintain the integrity of the Service.
                        </p>
                        <p className="page-intro">
                            <b>5.3 Service Availability</b><br />
                            While we strive to maintain high availability, we do not guarantee uninterrupted access to the Service. The Service may be temporarily unavailable due to maintenance, updates, or unforeseen circumstances. We are not liable for any downtime or service interruptions.
                        </p>
                    </div>

                    <div className="mb-24">
                        <h3 className="page-title mb-8">
                            6. Intellectual Property
                        </h3>
                        <p className="page-intro mb-16">
                            <b>6.1 Your Content</b><br />
                            You retain all intellectual property rights to your content. By using the Service, you grant us a limited license to store, process, and transmit your content solely for the purpose of providing the Service to you.
                        </p>
                        <p className="page-intro">
                            <b>6.2 Our Content</b><br />
                            The Service, including its design, features, and functionality, is owned by us. You may not copy, modify, or create derivative works of the Service. Our trademarks, logos, and brand names are our exclusive property.
                        </p>
                    </div>

                    <div className="mb-24">
                        <h3 className="page-title mb-8">
                            7. Subscription and Payment
                        </h3>
                        <p className="page-intro mb-16">
                            <b>7.1 Free and Paid Plans</b><br />
                            We may offer both free and paid subscription plans. Features and limitations may vary by plan, and we reserve the right to modify pricing and plan features with reasonable notice to users.
                        </p>
                        <p className="page-intro mb-16">
                            <b>7.2 Payment Terms</b><br />
                            Payments are processed through secure third-party payment processors. All fees are non-refundable unless otherwise stated in your subscription agreement. You are responsible for any applicable taxes related to your use of the Service.
                        </p>
                        <p className="page-intro">
                            <b>7.3 Right of Withdrawal (EU Consumers)</b><br />
                            If you are a consumer residing in the European Union, you have the right to withdraw from a paid subscription within 14 days of purchase.
                        </p>
                    </div>

                    <div className="mb-24">
                        <h3 className="page-title mb-8">
                            8. Termination
                        </h3>
                        <p className="page-intro mb-16">
                            <b>8.1 By You</b><br />
                            You may terminate your account at any time through your account settings. Upon termination, you may export your data before account deletion. We may retain certain data as required by law or for legitimate business purposes.
                        </p>
                        <p className="page-intro">
                            <b>8.2 By Us</b><br />
                            We may suspend or terminate your account if you violate these Terms or engage in conduct that we determine is harmful to other users or the Service. We may discontinue the Service with reasonable notice. Upon termination, your right to use the Service will immediately cease.
                        </p>
                    </div>

                    <div className="mb-24">
                        <h3 className="page-title mb-8">
                            9. Disclaimers and Limitations of Liability
                        </h3>
                        <p className="page-intro mb-16">
                            <b>9.1 Service Provided "As Is"</b><br />
                            The Service is provided "as is" and "as available" without warranties of any kind, either express or implied. We do not guarantee that the Service will be error-free, secure, or uninterrupted. We disclaim all warranties, including but not limited to merchantability and fitness for a particular purpose.
                        </p>
                        <p className="page-intro mb-16">
                            <b>9.2 Limitation of Liability</b><br />
                            To the maximum extent permitted by law, we shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising from your use of the Service. Our total liability shall not exceed the amount you paid us in the 12 months preceding the claim. We are not liable for any loss of data, content, or information, even if we have been advised of the possibility of such damages.
                        </p>
                        <p className="page-intro">
                            <b>9.3 Data Loss Disclaimer</b><br />
                            We are not responsible for any loss of your data, content, or information. While we implement security measures and backup systems, data loss can occur due to various factors beyond our control. You acknowledge that maintaining local backups is your responsibility, and we strongly recommend regular exports of your work in PDF or XML formats.
                        </p>
                    </div>

                    <div className="mb-24">
                        <h3 className="page-title mb-8">
                            10. Indemnification
                        </h3>
                        <p className="page-intro">
                            You agree to indemnify and hold us harmless from any claims, damages, losses, liabilities, and expenses, including reasonable legal fees, arising from your use of the Service, your violation of these Terms, your violation of any rights of another party, or your content or conduct.
                        </p>
                    </div>

                    <div className="mb-24">
                        <h3 className="page-title mb-8">
                            11. Changes to Terms
                        </h3>
                        <p className="page-intro">
                            We reserve the right to modify these Terms at any time. We will notify you of material changes via email or through the Service. Your continued use of the Service after such changes constitutes acceptance of the modified Terms.
                        </p>
                    </div>

                    <div className="mb-24">
                        <h3 className="page-title mb-8">
                            12. Governing Law
                        </h3>
                        <p className="page-intro">
                            These Terms shall be governed by and construed in accordance with applicable laws, without regard to conflict of law provisions.
                        </p>
                    </div>

                    <div className="mb-24">
                        <h3 className="page-title mb-8">
                            13. Severability
                        </h3>
                        <p className="page-intro">
                            If any provision of these Terms is found to be unenforceable or invalid, that provision shall be limited or eliminated to the minimum extent necessary, and the remaining provisions shall remain in full force and effect.
                        </p>
                    </div>
                    <div className="mb-24">
                        <h3 className="page-title mb-8">
                            14. Force Majeure
                        </h3>
                        <p className="page-intro">
                        We shall not be liable for any failure or delay in performance resulting from events beyond our reasonable control, including but not limited to natural disasters, internet outages, cyberattacks, power failures, labor disputes, governmental actions, or failures of third-party hosting providers.
                        </p>
                    </div>
                </div>
            </div>

            <div className="divider"></div>

            <CTASection />
        </div>
    );
};

export default Terms;

